/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_By_ProvinceInputs */

const th_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรองตามจังหวัด`)
};

const en_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by province`)
};

const ja_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`県で絞り込む`)
};

const zh_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按府筛选`)
};

const es_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por provincia`)
};

const pt_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por província`)
};

const id_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saring menurut provinsi`)
};

const fr_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par province`)
};

const tl_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salain ayon sa lalawigan`)
};

const vi_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc theo tỉnh`)
};

const ko_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주로 거르기`)
};

const de_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Provinz filtern`)
};

const ru_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр по провинции`)
};

const tr_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İle göre süz`)
};

const it_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra per provincia`)
};

const pl_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtruj według prowincji`)
};

const uk_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фільтр за провінцією`)
};

const hi_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रांत के अनुसार छाँटें`)
};

const ar_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفية حسب المحافظة`)
};

const ms_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapis mengikut wilayah`)
};

const bn_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রদেশ অনুযায়ী ছাঁকুন`)
};

const zh_tw2_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依府篩選`)
};

const zh_hk2_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依府篩選`)
};

const ur_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صوبے کے مطابق چھانٹیں`)
};

const fa_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پالایش بر پایهٔ استان`)
};

const sw_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuja kwa mkoa`)
};

const nl_filter_by_province = /** @type {(inputs: Filter_By_ProvinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filteren op provincie`)
};

/**
* | output |
* | --- |
* | "Filter by province" |
*
* @param {Filter_By_ProvinceInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const filter_by_province = /** @type {((inputs?: Filter_By_ProvinceInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_By_ProvinceInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_filter_by_province(inputs)
	if (locale === "ja") return ja_filter_by_province(inputs)
	if (locale === "zh") return zh_filter_by_province(inputs)
	if (locale === "es") return es_filter_by_province(inputs)
	if (locale === "pt") return pt_filter_by_province(inputs)
	if (locale === "id") return id_filter_by_province(inputs)
	if (locale === "fr") return fr_filter_by_province(inputs)
	if (locale === "tl") return tl_filter_by_province(inputs)
	if (locale === "vi") return vi_filter_by_province(inputs)
	if (locale === "ko") return ko_filter_by_province(inputs)
	if (locale === "de") return de_filter_by_province(inputs)
	if (locale === "ru") return ru_filter_by_province(inputs)
	if (locale === "tr") return tr_filter_by_province(inputs)
	if (locale === "it") return it_filter_by_province(inputs)
	if (locale === "pl") return pl_filter_by_province(inputs)
	if (locale === "uk") return uk_filter_by_province(inputs)
	if (locale === "hi") return hi_filter_by_province(inputs)
	if (locale === "ar") return ar_filter_by_province(inputs)
	if (locale === "ms") return ms_filter_by_province(inputs)
	if (locale === "bn") return bn_filter_by_province(inputs)
	if (locale === "zh-TW") return zh_tw2_filter_by_province(inputs)
	if (locale === "zh-HK") return zh_hk2_filter_by_province(inputs)
	if (locale === "ur") return ur_filter_by_province(inputs)
	if (locale === "fa") return fa_filter_by_province(inputs)
	if (locale === "sw") return sw_filter_by_province(inputs)
	if (locale === "nl") return nl_filter_by_province(inputs)
	return en_filter_by_province(inputs)
});